import _ from 'lodash';

import { User } from 'ev-types';

import { UserIncludedElement, UserResponseData } from 'ev-api/core';
import { userTransform } from 'ev-api/core/users/transformers';
import { sanitizeIds } from 'ev-api/utils';

type ProvidersResponse = {
  data: UserResponseData[];
  included?: UserIncludedElement[];
};

/**
 * Transforms bulk providers response to Record<string, User> with only defined
 * users (strips null/undefined so consumers get a clean map).
 */
export const getProvidersTransform = (
  response: ProvidersResponse | null | undefined,
): Record<string, User> => {
  if (!response) {
    return {};
  }
  const sanitized = sanitizeIds(response);
  const data = sanitized.data;
  const included = sanitized.included ?? [];
  const users = (data.filter(Boolean) as UserResponseData[]).map(item =>
    userTransform({ data: item, included }),
  );
  return _.keyBy(users, 'id');
};

export const getProviderTransform = (
  response: ProvidersResponse | null | undefined,
): User | undefined => {
  const providerData = response?.data[0];
  if (!providerData) {
    return undefined;
  }
  return userTransform({
    data: providerData,
    included: response.included ?? [],
  });
};
